import { Link } from "react-router-dom";
import { SplitkartLogo } from "@/components/SplitkartLogo";

const solutionLinks = [
  { label: "Home", href: "/" },
  { label: "How it Works", href: "/how-it-works" },
  { label: "Pricing", href: "/pricing" },
  { label: "ROI Calculator", href: "/#roi" },
];

const resourceLinks = [
  { label: "FAQ", href: "/faq" },
  { label: "Contact Us", href: "/contact" },
  { label: "How Split Payments Work", href: "/how-split-payments-work" },
];

const supportLinks = [
  { label: "Enquiries & Demos", href: "/contact" },
  { label: "Support", href: "/contact" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Service", href: "/terms-of-service" },
];

export function MarketingFooter() {
  return (
    <footer className="border-t border-border bg-surface">
      <div className="container-tight py-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="space-y-5">
            <SplitkartLogo />
            <p className="max-w-sm text-sm leading-7 text-slate-600">
              Effortless group gifting and split payments at checkout.
            </p>
          </div>

          <FooterColumn title="Solution" links={solutionLinks} />
          <FooterColumn title="Resources" links={resourceLinks} />
          <FooterColumn title="Support / Legal" links={supportLinks} />
        </div>

        <div className="mt-12 border-t border-border pt-8">
          <p className="text-xs text-muted-foreground">© 2026 Splitkart™. A Shakatah Company.</p>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({
  title,
  links,
}: {
  title: string;
  links: { label: string; href: string }[];
}) {
  return (
    <div>
      <h3 className="mb-4 text-xs font-semibold uppercase tracking-wider text-foreground">{title}</h3>
      <ul className="space-y-3 text-sm text-muted-foreground">
        {links.map((link) => (
          <li key={link.label}>
            {link.href.startsWith("/") ? (
              <Link className="transition-colors hover:text-primary" to={link.href}>
                {link.label}
              </Link>
            ) : (
              <a className="transition-colors hover:text-primary" href={link.href}>
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
